export default __webpack_public_path__ + "static/media/message.9a73c2db.svg";